import { CALL_API } from './api'
// import moment from 'moment'
import {
    getAllCookies,
    // TOKEN,
    EXPIRES_ON,
} from 'Lib'

export default store => next => action => {
    const entry = action[CALL_API]


    if (typeof entry !== 'object') return next(action)

    const allCookies = getAllCookies()

    if (allCookies && allCookies[EXPIRES_ON]) {
        // const currentTime = moment()
        //     , expireDate = moment.unix(allCookies[EXPIRES_ON])
        // if (expireDate.isValid()) {

        // } else {
        //     next(action)
        // }
        next(action)
    } else {
        next(action)
    }
    // const expire = getTokenExpire() //EXPIRES_ON

    // const currentTime = moment().tz(getTimeZone())
    // const duration = moment.duration(moment.unix(expire).diff(currentTime))
    // const minutes = duration.asMinutes()
    // if (minutes < 5) {
    //     fetch(`${CORE_API_ENDPOINT}/user/newtoken`, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             // 'Authorization': `Bearer ${getBSRSToken()}`
    //         },
    //         body: JSON.stringify({
    //             'id': getUserId()
    //         })
    //     })
    //         .then(res => res.json())
    //         .then(json => setRefreshToken(json))
    //         .then(() => next(action))
    // } else {
    //     next(action)
    // }



}


// WEBPACK FOOTER //
// ./src/middlewares/checkToken.js